
// ReSharper disable InconsistentNaming
define('coach/cumulative/view/models/dashboard-model',['jquery',
        'backbone',
        '_',
        'services',
        'usage-log-event'],
    function ($, Backbone, _, services, UsageLogEvent) {
        'use strict';

        var DashboardModel = Backbone.Model.extend({
            initialize: function (options) {
                this.attributes = this.parse(options);
                this.on('change:seasonId', this.fetchModel, this);
            },
            url: function() {
                return services('getViewModel', {
                    teamId: this.get('teamId'),
                    seasonId: this.get('seasonId')
                })._serviceUrl;
            },
            parse: function (response, options) {
                if (response.season) {
                    response.seasonId = response.season.seasonId;
                }

                return response;
            },
            fetchModel: function () {
                var self = this;
                this.fetch({
                    success: function (model, response, options) {
                        if (!response.previousSeasonId) {
                            self.unset('previousSeasonId');
                            self.unset('previousSeasonUrl');
                        }
                        if (!response.nextSeasonId) {
                            self.unset('nextSeasonId');
                            self.unset('nextSeasonUrl');
                        }
                        self.trigger('model-updated');
                    },
                    error: function () {
                        console.error(arguments);
                        //TODO: Figure out what to display on error
                    }
                });
            },
            setNotification: function (message, type) {
                this.set('notification', {
                    message: message,
                    type: type
                });
            },
            log: function (logData) {
                this.usageLog = new UsageLogEvent({
                    logger: 'StatsCoachCumulativeUsage'
                });

                logData = logData || {};
                logData.op = 'Stats';
                logData.team = this.get('teamId');

                this.usageLog.log(logData);
            }
        });

        return DashboardModel;
    });
